module.exports = __webpack_public_path__ + "b5ee0641424f4dd19861f2bb4e2cce19.pdf";